import { useAPI } from "~/uses/useMyFetch";
import { useFilterStore } from "~/store/filterStore";
import { filterConfig } from "~/config/filterParam.config";

export const useCriteriaStore = defineStore("criteriaStore", {
  state: () => {
    return {
      criteria: null,
    };
  },
  actions: {
    async fetch() {
      await useAPI("/catalog/product/criteria", {
        params: this.buildRequestParams(),
        lazy: true,
      }).then((data) => {
        this.criteria = data;
      });
    },
    buildRequestParams() {
      const params = Object.entries(useFilterStore().params).filter(
        ([k, _]) => !["page", "limit"].includes(k),
      );
      const requestParams = {};

      for (const [paramKey, paramValue] of params) {
        requestParams[filterConfig[paramKey].request?.alias ?? paramKey] =
          filterConfig[paramKey].request?.encode(paramValue) ??
          filterConfig[paramKey].state.encode(paramValue);
      }

      return requestParams;
    },
  },
  getters: {
    getCriteria: (state) => state.criteria,
    getPriceRange: (state) => state.criteria.priceRange,
    getSpecification: (state) => {
      return (slug) => {
        return state.criteria.specifications.find(
          (specification) => specification.slug === slug,
        );
      };
    },
    getSpecificationOption: (state) => {
      return (slug, optionSlug) => {
        return state
          .getSpecification(slug)
          ?.options.find((option) => option.slug === optionSlug);
      };
    },
  },
});
